<div class="error-message">
  <div class="error-content">
    <svg
      width="80"
      height="80"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
        fill="white"
        opacity="0.9"
      />
    </svg>
    <h2>Manglende Location ID</h2>
    <p>Tilføj venligst en <code>locationId</code> parameter til URL'en</p>
    <p class="example">Eksempel: <code>?locationId=123</code></p>
  </div>
</div>
